import {PageView} from './PageView.js'
import {UserProfileLayout} from '../components/layout/UserProfileLayout.js'
import {Header} from '../components/Header.js'
import {NameInput} from '../components/input/NameInput.js'
import {PasswordInput} from '../components/input/PasswordInput.js'
import {TermPopup} from '../components/popup/TermPopup.js'
import {InputValidator} from '../util/input-validate/inputValidation.js'
import {
    addPassword, addPhoneAuthCompleted, addPhoneNumber,
    addUserName,
    collectGtm, getPhoneAuthCompleted,
    getPlanId,
    getUser,
    getUserId,
    getUserName,
    isSnsSignUp
} from '../store.js'
import {LoadingPopup} from "../components/popup/LoadingPopup.js";
import {ERROR_CODE} from "../constant.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {PhoneNumberInput} from "../components/input/PhoneNumberInput.js";
import PhoneAuth from "../components/input-group/PhoneAuth.js";

export class InvitationUserFormView extends PageView {
    renderLayout() {
        const {mainText = '', subText = ''} = this.$props;
        const userId = getUserId();
        const region = window._CLIENT_REGION || 'KR';

        this.$props.UserProfileLayout = new UserProfileLayout(this.$target, {
            isAppend: true,
            sectionId: this.getSectionId(),
            mainText,
            subText,
            userId,
            nextButton: {
                id: 'invitationUserFormSubmit',
                text: this.getNextButtonText(),
                nextPageFunc: this.nextPage.bind(this),
                disabled: Often.isGlobal() ? false : region === 'KR',
            },
        })
    }

    renderComponents() {
        if (!this.$props.UserProfileLayout) {
            return
        }

        new Header(this.$props.UserProfileLayout.getHeaderLayer(), {
            isShowLoginBtn: false,
            isShowPrevBtn: true,
        })

        this.$props.NameInput = new NameInput(this.$props.UserProfileLayout.getUserNameLayer(), {
            isLast: Often.isGlobal(),
            addClassName: this.getJoinInputClassName(),
            submit : this.nextPage.bind(this),
            value : isSnsSignUp() ? getUserName() : "",
        })

        const passwordInput = new PasswordInput(this.$props.UserProfileLayout.getPasswordLayer(), {
            allowBlank: false,
            addClassName: this.getJoinInputClassName(),
        })

        this.$props.PasswordInput = isSnsSignUp() ? null : passwordInput

        if (!Often.isGlobal()) {
            const region = window._CLIENT_REGION || 'KR'
            if (region === 'KR') {
                this.$props.PhoneAuth = PhoneAuth();
                this.$props.PhoneAuth.init({
                    target: this.$props.UserProfileLayout.getPhoneAuthLayer(),
                    renderOption: 'append',
                })
                return;
            }
            this.$props.PhoneNumberInput = new PhoneNumberInput(this.$props.UserProfileLayout.getPhoneAuthLayer(), {
                isLast: true,
                addClassName: this.getJoinInputClassName(),
                submit: this.nextPage.bind(this),
            })
        }
    }

    getSectionId() {
        return `invitationUserFormSection`
    }

    getJoinInputClassName() {
        return `js-join-input`
    }

    setUserData() {
        addUserName(this.$props.NameInput.getInputValue())
        if (this.$props?.PasswordInput !== null) {
            addPassword(this.$props.PasswordInput.getInputValue())
        }
        addPhoneNumber($('#phoneNumberInput').val())
    }

    async nextPage() {
        const $invitationUserFormSection = $(`#${this.getSectionId()}`)
        const $formInputs = $invitationUserFormSection.find(`.${this.getJoinInputClassName()}`)
        if (!InputValidator.inputsValidate($formInputs)) {
            return
        }

        if (!Often.isGlobal()) {
            const region = window._CLIENT_REGION || 'KR'
            if (region === 'KR') {
                if (!getPhoneAuthCompleted()) {
                    await this.verifyAuthCode();
                }
                if (!getPhoneAuthCompleted()) {
                    this.$props.PhoneAuth.validatePhoneAuthInputs()
                    return
                }
            }
            this.setUserData();
            new TermPopup($invitationUserFormSection, {
                isAppend: true,
            })
            return
        }

        // global
        this.setUserData();
        const planId = getPlanId();
        const isJoinAsAGuestForMM = !!planId && planId.indexOf("BASIC") > -1;
        if (isJoinAsAGuestForMM) { //Join as a guest (모메는 게스트 없어서 회사가입)
            SignUpViewChanger.loadCompanyInviteView();
            return
        }
        //Join as a teammate
        //모메는 동의 팝업 없음!
        const $loadingPopupArea = $(this.$target).find("article");
        new LoadingPopup($loadingPopupArea, {
            isAppend: true,
            loadingText: i18next.t(common.wait)
        });

        if (!Mutil.empty(window?.CONNECT_INVITE_KEY)) {
            const data = await getUser().joinCompanyBySubDom()
            const result = Mutil.n2v(data.ERROR_CODE) === ERROR_CODE.SUCCESS
            if (!result) {
                Mutil.toast('error', i18next.t(common.occupy, {
                    val: $t(dictionary.email)
                }))
            }

            new LoadingPopup($('body'), {})

            const passWaiting = Mutil.n2v(data.JNNG_ATHZ_YN, 'N') === 'Y'
            if (passWaiting) {
                const gtmEvent = Often.isGlobal() ? 'new_signup6' : 'new_joinup3_a'
                collectGtm(gtmEvent)
                getUser().signInWithTwoFactor(data)
                return
            }

            SignUpViewChanger.loadCompanyJoinWaitView();
            return
        }

        Mutil.mlog("CONNECT_INVITE_KEY 값이 없습니다.!!!")
    }

    async verifyAuthCode() {
        const $target = this.$props.UserProfileLayout.getPhoneAuthLayer()
        const $authCodeInput = $target.find('#authCodeInput')
        const $authCountMessage = $target.find('.js-counter-message')

        // confirm auth code
        const authResult = await this.$props.PhoneAuth.verifyAuthCode()
        if (!authResult) {
            $authCodeInput.closest('.js-interactive-form-wrap').addClass('status-error')
            $authCountMessage.text(i18next.t(main.alert.verificationNotMatch))
            return
        }

        $target.find('#phoneNumberInput').attr('disabled', true)
        $target.find('.js-phone-auth-button').attr('disabled', true)
        $authCodeInput.attr('disabled', true)
        $target.find('.js-counter-wrap').hide()

        addPhoneAuthCompleted(true)
        this.$props.PhoneAuth.stopCounter()
    }
}
